import { useContext } from 'react'
import { useTheme } from '@mui/material'
import {
  EdgeLabelRenderer,
  getStraightPath,
  BezierEdge,
  Position,
} from '@xyflow/react'
import { PlaybookContext } from '../../../../contexts/playbooks.context'

interface IProps {
  id: string
  data: any
  source: string
  sourceX: number
  sourceY: number
  targetX: number
  targetY: number
  sourcePosition: Position
  targetPosition: Position
}

const LabeledEdge: React.FC<IProps> = ({
  id,
  data,
  source,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  ...props
}) => {
  const { runState } = useContext(PlaybookContext)

  // The entry in the palette:
  let color: 'primary' | 'warning' = 'primary'

  if (data?.label) {
    // TODO: encapsulate this string, ideally shared with backend code:
    const branchResult: string[] = runState[`__${source}_branch`] || []
    if (branchResult.includes(data?.label)) color = 'warning'
  }

  const [, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  })

  const theme = useTheme()

  return (
    <>
      <BezierEdge
        id={id}
        sourceX={sourceX}
        sourceY={sourceY}
        targetX={targetX}
        targetY={targetY}
        sourcePosition={sourcePosition}
        targetPosition={targetPosition}
      />
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              background: theme.palette[color].main,
              color: theme.palette[color].contrastText,
              padding: '5px 10px',
              borderRadius: '5px',
              fontSize: '12px',
              fontWeight: 'bold',
              pointerEvents: 'all', // Important for interactivity
            }}
            className="nodrag nopan" // Prevents dragging/panning when interacting with the label
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}

export const edgeTypeComponents = {
  default: LabeledEdge,
}

export default LabeledEdge
